import { useMemo } from 'react'

import { useOpenWindow } from '@krp/client-runtime'
import {
  AQSI_WINDOWS,
  aqsiReceipt,
  aqsiReceiptRegisters,
  makeSelectReceiptDetailVm,
  receiptsReloadRequested,
  ReceiptLinesPanel,
  type ReceiptArgs,
} from '@krp/resource-aqsi-ui'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import type { RootState } from '../../app/types'

/**
 * Товары чека AQSI под раскрытой строкой списка: тот же запрос и тот же vm, что у окна чека (`ReceiptDetailBinding`), поэтому
 * «Подробнее» после раскрытия открывается без второго чтения. Позиция с ключом товара открывает карточку товара AQSI поверх экрана.
 */
export function ReceiptLinesBinding({ resourceId, receiptId }: { resourceId: string; receiptId: string }) {
  const dispatch = useAppDispatch()
  const openWindow = useOpenWindow()
  const args = useMemo<ReceiptArgs>(() => ({ resourceId, receiptId }), [resourceId, receiptId])
  aqsiReceipt.useQuerySubscription(args, { skip: resourceId === '' || receiptId === '' })
  // «Возвращено» по позициям — по признаку журнала этого rid, как в окне чека.
  const registersArgs = useMemo(() => ({ resourceId }), [resourceId])
  aqsiReceiptRegisters.useQuerySubscription(registersArgs, { skip: resourceId === '' })
  const selectVm = useMemo(() => {
    const selectPackageVm = makeSelectReceiptDetailVm()
    const selectQuery = aqsiReceipt.select(args)
    const selectRegisters = aqsiReceiptRegisters.select(registersArgs)
    return (state: RootState) =>
      selectPackageVm({ query: selectQuery(state), refundsKnown: selectRegisters(state).data?.state.refundsKnown })
  }, [args, registersArgs])
  const vm = useAppSelector(selectVm)
  return <ReceiptLinesPanel vm={vm} onRetry={() => dispatch(receiptsReloadRequested({ resourceId }))}
    openGood={(key) => openWindow(AQSI_WINDOWS.good, { rid: resourceId, key })} />
}
